import React from "react";
import { Box, Stack } from "@mui/material";

const TableFilterBar = ({ search, filters, trailing, sx }) => (
  <Stack
    direction={{ xs: "column", md: "row" }}
    spacing={1}
    alignItems={{ xs: "stretch", md: "center" }}
    sx={sx}
  >
    {search}
    {filters ? (
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        sx={{ minWidth: 0 }}
      >
        {filters}
      </Stack>
    ) : null}
    <Box sx={{ flexGrow: 1 }} />
    {trailing ? (
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {trailing}
      </Stack>
    ) : null}
  </Stack>
);

export default TableFilterBar;
